import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from "react-bootstrap";

import { NavLink } from "react-router-dom";


import { FaFacebookF, FaInstagram, FaPinterest, FaTwitter, FaYoutube, FaTiktok } from "react-icons/fa";


function Footer() {

    return (

        <Container className='bg-dark' fluid>

      <br/>

        <Container className='bg-dark'>
            <Row className="text-white">
                <Col sm style={{ marginBottom: 30}}>
                    <p><strong>บริการลูกค้า</strong></p>
                    
                    <NavLink to="/DownloadApp" style={{ color: "gray", textDecoration: 'none' }}>ดาวน์โหลด</NavLink> 
                    <br/>
                    <NavLink to="/HowToPurchase" style={{ color: "gray", textDecoration: 'none' }}>ขั้นตอนการซื้อ</NavLink> 
                    <br/>
                    <NavLink to="/HowToRead" style={{ color: "gray", textDecoration: 'none' }}>วิธีอ่านหนังสือ</NavLink>
                    {/* <br/>
                    <NavLink to="/AboutUs/QPoint" style={{ color: "gray", textDecoration: 'none' }}>คะแนนสะสม</NavLink> */}
                </Col>

                <Col sm style={{ marginBottom: 30 }}>
                    <p><strong>เกี่ยวกับเรา</strong></p>
                    
                    <NavLink to="/Contact" style={{ color: "gray", textDecoration: 'none' }}>ติดต่อเรา</NavLink>
                    <br/>
                    <NavLink to="/TermsOfService" style={{ color: "gray", textDecoration: 'none' }}>ข้อกำหนดการให้บริการ</NavLink> 
                    <br/>
                    <NavLink to="/AboutUs" style={{ color: "gray", textDecoration: 'none' }}>เกียวกับ EduLaw</NavLink> 
      
                    
                    {/* <br/>
                    <NavLink to="/" style={{ color: "gray", textDecoration: 'none' }}>???ขายของกับเรา</NavLink> */}
                </Col>

                <Col sm style={{ marginBottom: 30 }}>
                    
                </Col>

                <Col sm style={{marginTop: 8, display:'flex', justifyContent:'right'}}>

              </Col>
            </Row>
        </Container>

        <Container className='bg-dark' fluid>

        <Container>
            
        <br/>
        <Row className="text-white">
          <Col sm>
           
            <h3 style={{fontWeight: 'bold'}}>EduLaw</h3>
           
          </Col>
          <Col sm style={{marginTop: 8}}>
            <p>© 2025 EduLaw. All Rights Reserved.</p>
          </Col>
          <Col>
          </Col>
          <Col sm className="justify-content-end" style={{marginTop: 8, display:'flex', justifyContent:'right'}}>
            <a href="https://www.facebook.com/profile.php?id=100028543045358&mibextid=LQQJ4d" target="_blank" rel="noreferrer" style={{textDecoration: 'none', color: "white"}}><FaFacebookF/></a>&nbsp;&nbsp;&nbsp;
            <a href="https://www.instagram.com/chicchic_pichitnati?igsh=d3MyZHQzNnAybnBh" target="_blank" rel="noreferrer" style={{textDecoration: 'none', color: "white"}}><FaInstagram/></a>&nbsp;&nbsp;&nbsp;
            {/* <a href="https://www.pinterest.com/enquexofficial/" target="_blank" rel="noreferrer" style={{textDecoration: 'none', color: "white"}}><FaPinterest/></a>&nbsp;&nbsp;&nbsp; */}
            {/* <a href="https://www.youtube.com/channel/UC0WH6pCsd6t4puoKOxY1zHg" target="_blank" rel="noreferrer" style={{textDecoration: 'none', color: "white"}}><FaYoutube/></a>&nbsp;&nbsp;&nbsp; */}
            <a href="https://www.tiktok.com/@chichic.codeoflaw?_t=8mmKa9uNKfi&_r=1" target="_blank" rel="noreferrer" style={{textDecoration: 'none', color: "white"}}><FaTiktok/></a>&nbsp;&nbsp;&nbsp;
            {/* <a href="https://twitter.com/enquex_official" target="_blank" rel="noreferrer" style={{textDecoration: 'none', color: "white"}}><FaTwitter/></a> */}
          
          </Col>
        </Row>
            <br/>

        </Container>
            
      </Container>

      </Container>

    );

}

export default Footer;